import { createTracker } from 'usage-tracker';
import events from 'framework-asset-preview-lib/events.yaml';

/**
 * TODO: Remove this once all usages have been updated to support standalone trackers
 * (eg https://git.hubteam.com/HubSpot/framework-asset-preview-lib/blob/7e6c2f02d9a688cd5c9f8cdedcaa21403f8f5fe4/framework-asset-preview-lib/static-1.34578/js/internal/objectTypes/0-29/hooks/useRenderPropertyValue.tsx#L99)
 */
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'framework-asset-preview-lib'
  }
});
export const StandaloneTracker = createTracker({
  properties: {
    namespace: 'framework-asset-preview-lib'
  },
  standalone: true
});